<script lang="ts">
  /* The blue «?» of the help-icon pair (2026-08-14 rule): the black InfoTooltip
     beside it says what a section is for; this one opens the how-to panel —
     «Как работает · Что нужно сделать · Частые вопросы» — for the block named
     by `id`, read from the `lib/guides` registry. Drop it right after the
     InfoTooltip in a page's `.title-row`. */
  import { _ } from "svelte-i18n";
  import GuideBody from "$components/GuideBody.svelte";
  import { guideById, type GuideId } from "$lib/guides";

  let { id }: { id: GuideId } = $props();
  const guide = $derived(guideById(id));
  let open = $state(false);
  let panelEl = $state<HTMLDivElement | null>(null);

  $effect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      requestAnimationFrame(() => panelEl?.focus());
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  });
</script>

<button
  type="button"
  class="tips-btn"
  onclick={() => (open = true)}
  title={$_("guide.cta")}
  aria-label={$_("guide.cta")}
>
  <span class="material-icons-outlined">help_outline</span>
</button>

{#if open}
  <div class="help-backdrop" role="presentation" onclick={() => (open = false)}></div>
  <div
    class="help-panel"
    role="dialog"
    aria-modal="true"
    aria-label={$_(`guide.${id}.title`)}
    tabindex="-1"
    bind:this={panelEl}
    onkeydown={(e) => e.key === "Escape" && (open = false)}
  >
    <div class="help-panel-header">
      <span class="material-icons-outlined help-panel-icon">{guide.icon}</span>
      <h2 class="help-panel-title">{$_(`guide.${id}.title`)}</h2>
      <button class="help-close" onclick={() => (open = false)} aria-label={$_("common.close")}>
        <span class="material-icons-outlined">close</span>
      </button>
    </div>
    <GuideBody {id} />
    <button class="help-done" onclick={() => (open = false)}>{$_("linkRequests.help.done")}</button>
  </div>
{/if}

<style>
  /* Same shape as InfoTooltip's button; the colour alone says "how-to". */
  .tips-btn {
    display: inline-flex; align-items: center; justify-content: center;
    border: none; background: none; padding: 2px; margin: 0; cursor: pointer;
    color: var(--color-primary); border-radius: 50%; line-height: 1;
    transition: background 0.15s;
  }
  .tips-btn:hover { background: rgba(33,133,213,0.1); }
  .tips-btn:focus-visible { outline: 2px solid var(--color-primary); outline-offset: 1px; }
  .tips-btn .material-icons-outlined { font-size: 18px; }

  .help-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.35); z-index: 1000; }
  .help-panel {
    position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1001;
    background: #fff; border-radius: 12px; box-shadow: 0 8px 40px rgba(0,0,0,0.18);
    width: 520px; max-width: calc(100vw - 32px); max-height: calc(100vh - 40px); overflow-y: auto;
    padding: 24px 26px 22px; display: flex; flex-direction: column; gap: 16px; outline: none;
  }
  .help-panel-header { display: flex; align-items: center; gap: 10px; }
  .help-panel-icon { font-size: 24px !important; color: var(--color-primary); flex-shrink: 0; }
  .help-panel-title { margin: 0; font-size: 17px; font-weight: 700; flex: 1; }
  .help-close { margin-left: auto; border: none; background: none; cursor: pointer; color: var(--color-text-muted); padding: 4px; border-radius: 4px; display: flex; }
  .help-close:hover { background: #f0f0f0; color: #333; }
  .help-close .material-icons-outlined { font-size: 20px !important; }
  .help-done { align-self: flex-end; background: var(--color-primary); color: #fff; border: none; padding: 9px 24px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; }
  .help-done:hover { opacity: 0.88; }
</style>
